import { render } from "./geo-payment-method-toggle.vue?vue&type=template&id=52e9666a&ts=true"
import script from "./geo-payment-method-toggle.ts?vue&type=script&lang=ts"
export * from "./geo-payment-method-toggle.ts?vue&type=script&lang=ts"

import "./geo-payment-method-toggle.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__